export const radioOptions = [
  { label: 'Name/Code', value: 'nameCode' },
  { label: 'Hierarchy', value: 'hierarchy' },
];
